
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white text-gray-700 relative overflow-hidden border-t border-gray-200">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8 relative z-10">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Logo & Newsletter */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/eb276de5dddb9e260b685871ba0dd98c/67925e2f9ab9604353cb595c2b9db3a5.png" 
                alt="Pixel Anim Logo" 
                className="h-16 w-auto mb-4"
              />
              <h3 className="text-2xl font-bold bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent" style={{ fontFamily: "'Fredoka', sans-serif" }}>
                Pixel Anim
              </h3>
            </Link>
            <p className="text-gray-600 text-sm font-quicksand mb-4 leading-relaxed">
              Transformez vos souvenirs en magie animée
            </p>
          </div>

          {/* Column 2 - Navigation */}
          <div>
            <h4 className="text-sm font-quicksand font-bold uppercase mb-4 tracking-wide text-gray-900">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/creations" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Créations
                </Link>
              </li>
              <li>
                <Link to="/fonctionnement" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Fonctionnement
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Produits */}
          <div>
            <h4 className="text-sm font-quicksand font-bold uppercase mb-4 tracking-wide text-gray-900">Produits</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/creations" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Livres Personnalisés
                </Link>
              </li>
              <li>
                <Link to="/creations" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Personnages Animés
                </Link>
              </li>
              <li>
                <Link to="/creations" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Invitations
                </Link>
              </li>
              <li>
                <Link to="/creations" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Portraits Illustrés
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h4 className="text-sm font-quicksand font-bold uppercase mb-4 tracking-wide text-gray-900">Contact</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  Nous Contacter
                </Link>
              </li>
              <li>
                <a href="mailto:contact@pixel-anim.com" className="text-gray-600 hover:text-primary-blue transition-all duration-300 text-sm font-quicksand cursor-pointer hover:translate-x-1 inline-block">
                  contact@pixel-anim.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mb-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Copyright */}
          <div className="text-gray-600 text-sm font-quicksand">
            © 2025 Pixel Anim. Tous droits réservés. <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-primary-blue transition-colors cursor-pointer">Website Builder</a>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer text-gray-700 hover:text-primary-blue"
              aria-label="Facebook"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer text-gray-700 hover:text-primary-blue"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer text-gray-700 hover:text-primary-blue"
              aria-label="Twitter"
            >
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer text-gray-700 hover:text-primary-blue"
              aria-label="YouTube"
            >
              <i className="ri-youtube-fill text-lg"></i>
            </a>
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-6 text-sm font-quicksand text-gray-600">
            <Link to="/cgv" className="hover:text-primary-blue transition-colors cursor-pointer">
              CGV
            </Link>
            <Link to="/mentions-legales" className="hover:text-primary-blue transition-colors cursor-pointer">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="hover:text-primary-blue transition-colors cursor-pointer">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
